import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

const TopYouTubeVideos = () => {
  const videos = [
    { id: '_Ct5AFIgqxE', title: 'Roth IRA vs Traditional IRA - Which is Better?' },
    { id: 'fXHc2xE5xyY', title: 'How to Avoid Taxes on Social Security Benefits' },
    { id: '3mGTATYTVto', title: 'The Best Retirement Withdrawal Strategy' },
    { id: 'wEdMuvOH8tM', title: 'Medicare Supplement vs Medicare Advantage' },
    { id: 'tSJT5zhUhms', title: 'When Should You Take Social Security?' },
    { id: 'uJBSn4cgGN4', title: 'Tax-Free Retirement Income Strategies' },
    { id: 'R8iZzMSAmrY', title: 'How to Minimize Taxes in Retirement' },
    { id: 'QbbakhQkN2k', title: 'Additional Retirement Planning Tips' },
    { id: 'iA8mdhkXHsk', title: 'Advanced Tax Strategies for Retirees' }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Top Video's from Dan's Youtube Channel
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            RMD ages, contribution amounts and the tax table has changed since these recordings but the concepts are timeless.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {videos.map((video) => (
            <Card key={video.id} className="overflow-hidden hover:shadow-lg transition-shadow">
              <CardContent className="p-0">
                <div className="aspect-video">
                  <iframe
                    src={`https://www.youtube.com/embed/${video.id}`}
                    title={video.title}
                    className="w-full h-full"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-gray-900 line-clamp-2">
                    {video.title}
                  </h3>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TopYouTubeVideos;